import { useHistory, useLocation } from "react-router-dom"
import { GLOBAL_NAMESPACE, publishDict, usePubsub } from "../redux/pubsub"
import React from "react"

export function AppVarsInUrlSyncer(props: { varsToReplace?: string[]; varsToPush?: string[] }) {
  const varsToReplace = props.varsToReplace || []
  const varsToPush = props.varsToPush || []
  const history = useHistory()
  const location = useLocation()
  const [appVars] = usePubsub(GLOBAL_NAMESPACE)

  React.useEffect(() => {
    publishDict(getParams(location.search), GLOBAL_NAMESPACE, 'initial app vars from url params')
    return history.listen((location) => {
      if (history.action === 'POP') {
        publishDict(getParams(location.search), GLOBAL_NAMESPACE, 'app vars from "go back" or "go forward" with browser')
      }
    })
  }, [])

  React.useEffect(() => {
    const params = getParams(location.search)
    const newParams = new URLSearchParams(location.search)

    let shouldReplace = false
    for (const varName of varsToReplace) {
      if (params[varName] !== appVars[varName]) {
        shouldReplace = true
        newParams.set(varName, appVars[varName] as string)
      }
    }

    let shouldPush = false
    for (const varName of varsToPush) {
      if (params[varName] !== appVars[varName]) {
        shouldPush = true
        newParams.set(varName, appVars[varName] as string)
      }
    }

    if (shouldPush) {
      history.push({...location, search: newParams.toString()})
    } else if (shouldReplace) {
      history.replace({...location, search: newParams.toString()})
    }

  }, [appVars])

  return null
}

function getParams(locationSearch: string): Record<string, string> {
  return Object.fromEntries(new URLSearchParams(locationSearch)) as Record<string, string>
}
